import { useState, useEffect, useRef } from "react";
import { useIsUserLoggedIn, useLoginInfo } from "../../global-utils";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../global-state/redux/actions";
import ComponentsArrRenderer from "../core/ComponentsArrRenderer";
import { emptyNull } from "../../shared/misc";

const JwtTokenExpired = (props) => {
  const [hasExpired, setHasExpired] = useState(false);
  const timeoutRef = useRef(null);
  const isUserLoggedIn = useIsUserLoggedIn();
  const { expires_at: expiresAt } = useLoginInfo() ?? emptyNull;
  const components = useSelector((state) => state.appState?.settings?.jwtTokenExpired?.components);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!expiresAt || window.location.pathname === '/auth/login') return;

    const utcExpirationTime = new Date(expiresAt).getTime();
    const utcCurrentTime = Date.now();
    const timeUntilExpiration = utcExpirationTime - utcCurrentTime;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (timeUntilExpiration > 0) {
      timeoutRef.current = setTimeout(() => {
        setHasExpired(true);
      }, timeUntilExpiration);
    } else {
      setHasExpired(true);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [expiresAt]);

  const handleClick = () => {
    // We are using window redirect and not navigate because this component is not under browser router
    dispatch(logoutUser());
    window.location.href = '/auth/login';
  }
  
  // No reason to show the expired token message if the user is not logged in
  if (!hasExpired || !isUserLoggedIn) return null;

  if (components) {
    return <ComponentsArrRenderer {...props} components={components}/>;
  }
  
  
  return (
    <div className="jme-overlayer-wrapper">
      <div
        className="jme-overlayer-modal d-flex flex-column align-items-center text-align-center"
        style={{ padding: '24px', fontSize: '18px', borderRadius: '8px', gap: '16px' }}
      >
        Your session has expired. Please log in again.
        <button
          style={{
            width: 'fit-content',
            borderRadius: 75,
            padding: '4px 16px',
            background: 'var(--vsx-color-primary)',
            color: 'var(--vsx-button-text-color)'
          }}
          onClick={handleClick}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default JwtTokenExpired;